import { createClient } from "@supabase/supabase-js";

const supabaseUrl = import.meta.env.VITE_PUBLIC_SUPABASE_URL as string;
const supabaseAnonKey = import.meta.env.VITE_PUBLIC_SUPABASE_ANON_KEY as string;

export const supabase = createClient(supabaseUrl, supabaseAnonKey);

export interface DbNewsItem {
  id: string;
  slug: string;
  category: "grant-call" | "news" | "event" | "result";
  category_label: string;
  title: string;
  excerpt: string;
  body: string;
  date: string;
  deadline?: string | null;
  source?: string | null;
  image: string;
  tags?: string[] | null;
  status: "draft" | "published";
  created_at?: string;
  updated_at?: string;
}

export interface DbNewsTranslation {
  id?: string;
  news_id: string;
  language: string;
  title: string;
  excerpt: string;
  body: string;
  tags?: string[] | null;
  category_label: string;
  is_ai_translated?: boolean;
  created_at?: string;
  updated_at?: string;
}
